import React from "react";
import { Button, Card, Divider, Form, FormInstance, Input } from "antd";
import { useTranslation } from "react-i18next";
import { AcceptInviteDto, GetInviteInfoDto } from "../types/user";
import Title from "antd/es/typography/Title";
import { useAcceptInvite } from "../queries/user";

interface AcceptInviteFormProps {
  form: FormInstance;
  inviteInfo: GetInviteInfoDto;
  inviteToken: string | undefined;
}

export const AcceptInviteForm = ({
  form,
  inviteInfo,
  inviteToken,
}: AcceptInviteFormProps) => {
  const { t } = useTranslation();
  const { mutate: acceptInvite, isPending } = useAcceptInvite(
    inviteToken || "-1",
  );

  const onFinish = (values: AcceptInviteDto) => {
    acceptInvite({
      firstName: values.firstName,
      lastName: values.lastName,
      password: values.password,
    });
  };

  return (
    <Card title={t("pages.accept-invite.accept-invite")} style={{ width: 500 }}>
      <p>{t("pages.accept-invite.accept-invite-description-1")}</p>
      <Title level={3} style={{ marginTop: "1rem" }}>
        {inviteInfo.companyName}
      </Title>
      <p>{t("pages.accept-invite.accept-invite-description-2")}</p>

      <Divider />

      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item label={t("pages.accept-invite.email")} name="email">
          <Input disabled />
        </Form.Item>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Form.Item
            label={t("pages.accept-invite.first-name")}
            name="firstName"
            required
            style={{ marginRight: "1rem", width: "50%" }}
          >
            <Input
              required
              placeholder={
                t("pages.accept-invite.first-name-placeholder") || undefined
              }
            />
          </Form.Item>
          <Form.Item
            label={t("pages.accept-invite.last-name")}
            name="lastName"
            required
            style={{ marginLeft: "1rem", width: "50%" }}
          >
            <Input
              required
              placeholder={
                t("pages.accept-invite.last-name-placeholder") || undefined
              }
            />
          </Form.Item>
        </div>
        <Form.Item
          label={t("pages.accept-invite.password")}
          extra={t("pages.accept-invite.password-description")}
          name="password"
          required
          rules={[
            {
              required: true,
              message:
                t("pages.accept-invite.password-required") ||
                "Password is required",
            },
            {
              pattern:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&]{10,}$/,
              message:
                t("pages.accept-invite.password-policy") ||
                "Password must follow the policy below",
            },
          ]}
        >
          <Input.Password required style={{ marginBottom: "0.3rem" }} />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            style={{ float: "right" }}
            type="primary"
            htmlType="submit"
            loading={isPending}
          >
            {t("pages.accept-invite.confirm")}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
